/**
 * Search results list — paginated list of matching verses.
 */

import { observer } from 'mobx-react-lite';
import { bibleState } from '@/state/bible-state';
import { SearchResultItem } from './search-result-item';
import { LoadingSpinner } from '@components/icons';

export const SearchResultsList = observer(function SearchResultsList() {
  const {
    searchResults,
    searchTotal,
    searchText,
    searchHighlightTerms,
    isSearching,
    searchHasMore,
    searchReferenceMatch,
    searchReferenceLabel,
  } = bibleState;

  const jumpButton = searchReferenceMatch && (
    <button
      className="search-jump-ref"
      onClick={() => bibleState.jumpToSearchReference()}
    >
      <span className="search-jump-ref-label">Go to</span>
      <span className="search-jump-ref-target">{searchReferenceLabel}</span>
      <span className="search-jump-ref-hint">Enter ↵</span>
    </button>
  );

  if (!searchText.trim()) {
    return (
      <div className="search-empty-state">
        <p>Enter a word, phrase, or verse reference (e.g. Romans 8:28).</p>
      </div>
    );
  }

  if (isSearching && searchResults.length === 0) {
    return (
      <div className="search-results-list">
        {jumpButton}
        <div className="search-loading">
          <LoadingSpinner className="h-5 w-5" />
          <span>Searching...</span>
        </div>
      </div>
    );
  }

  if (searchResults.length === 0) {
    return (
      <div className="search-results-list">
        {jumpButton}
        <div className="search-empty-state">
          <p>No results found for &ldquo;{searchText}&rdquo;</p>
        </div>
      </div>
    );
  }

  return (
    <div className="search-results-list">
      {jumpButton}
      <div className="search-results-count">
        {searchTotal.toLocaleString()} verse{searchTotal !== 1 ? 's' : ''} found
      </div>
      {searchResults.map((result, i) => (
        <SearchResultItem
          key={`${result.testament}-${result.bookNumber}-${result.chapterNumber}-${result.verseNumber}-${i}`}
          result={result}
          searchText={searchHighlightTerms || searchText}
        />
      ))}
      {searchHasMore && (
        <button
          className="search-load-more"
          onClick={() => bibleState.loadMoreSearchResults()}
          disabled={isSearching}
        >
          {isSearching ? 'Loading...' : 'Load more'}
        </button>
      )}
    </div>
  );
});
